(function () {
  'use strict';

  if (window.AxiomCollapsible) return;
  window.AxiomCollapsible = true;

  function setOpen(collapsible, expanded) {
    collapsible.classList.toggle('is-open', expanded);
    var trigger = collapsible.querySelector('[data-product-collapsible-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', String(expanded));
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-product-collapsible-trigger]');
    if (!trigger) return;

    var collapsible = trigger.closest('[data-product-collapsible]');
    if (!collapsible) return;

    setOpen(collapsible, !collapsible.classList.contains('is-open'));
  });

  // Theme editor: a selected FAQ question, Accordion or Collapsible tab opens, so the merchant
  // sees the answer being edited, and closes again on deselect unless it was open already.
  function collapsibleFor(target) {
    var editor = window.Axiom && window.Axiom.editor;
    return editor ? editor.blockElement(target, '[data-product-collapsible]') : null;
  }

  document.addEventListener('shopify:block:select', function (event) {
    var collapsible = collapsibleFor(event.target);
    if (!collapsible || collapsible.classList.contains('is-open')) return;
    collapsible.dataset.editorOpened = 'true';
    setOpen(collapsible, true);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var collapsible = collapsibleFor(event.target);
    if (!collapsible || collapsible.dataset.editorOpened !== 'true') return;
    delete collapsible.dataset.editorOpened;
    setOpen(collapsible, false);
  });
})();
